/** @format */

// eslint-disable-next-line @mpb-com/mpb/require-constants-file -- Legacy code: do not use as an example.
export enum PaginationVariant {
    PAGE_SELECT = 'page_select',
    VIEW_MORE = 'view_more',
}

// eslint-disable-next-line @mpb-com/mpb/require-constants-file -- Legacy code: do not use as an example.
export enum SearchResultsVariant {
    MODEL = 'model',
    PRODUCT = 'product',
}

// eslint-disable-next-line @mpb-com/mpb/require-constants-file -- Legacy code: do not use as an example.
export enum PaginationControlsPosition {
    TOP = 'top',
    BOTTOM = 'bottom',
}

/**
 * Represents the type of message that should be displayed at the end of search results
 */
// eslint-disable-next-line @mpb-com/mpb/require-constants-file -- Legacy code: do not use as an example.
export enum SearchMessageType {
    /**
     * Represents the message that is displayed when the user has tried to navigate out of bounds
     */
    OUT_OF_BOUNDS,

    /**
     * Represents the message that is displayed when the user has reached the end of results on a model listings page.
     */
    END_OF_RESULTS_MODEL,

    /**
     * Represents the message that is displayed when the user has reached the end of results on a model listings page.
     */
    END_OF_RESULTS_PRODUCT,

    /**
     * Represents the message to be displayed when there are no results.
     */
    NO_RESULTS,
}
